import styled, { css } from 'styled-components'
import { rgba } from 'polished'

// Components
import { ButtonUnstyled } from 'components/Button'

// Icons
import { ReactComponent as Plus } from 'icons/plus-16.svg'
import { ReactComponent as Minus } from 'icons/minus-16.svg'

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  border: 1px solid ${({ theme }) => theme.colors.border.dark.base};
  border-radius: 7px;
`

export const StepperButton = styled(ButtonUnstyled)`
  padding: 10px; /* stylelint-disable-line scales/space */
  line-height: 0;

  color: ${({ theme }) => theme.colors.gray};

  :disabled {
    color: ${({ theme }) => rgba(theme.colors.black, 0.25)};
  }

  :hover,
  :focus {
    color: ${({ theme }) => theme.colors.text.dark.primary};
  }
`

const svgStyle = css`
  width: 16px;
  height: 16px;

  color: currentColor;
`

export const StyledPlus = styled(Plus)`
  ${svgStyle}
`

export const StyledMinus = styled(Minus)`
  ${svgStyle}
`

export const StepperInput = styled.input`
  border: none;
  padding: 0;
  margin: 0 5px; /* stylelint-disable-line scales/space */
  appearance: none;
  outline: none;
  text-align: center;

  /* We need to add this rule so we can disable the Firefox browser steppers. */
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -moz-appearance: textfield;

  /* Hide the browser steppers */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-appearance: none;
    margin: 0;
  }
`
